import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
	selector: 'app-edita-stato',
	templateUrl: './edita-stato.component.html',
	styleUrls: ['./edita-stato.component.css']
})
export class EditaStatoComponent implements OnInit {

	@Input() selected : any = {
		newState : false,
		state : {
			id : '',
			nome : '',
			descrizione : '',
			tipo : '',
			codice : '',
			atto : false,
			bollettino : false,
			rate : false
		},
		settings : {
			top : '0px',
			left : '0px',
			delayField : '',
			delayCondition : '==',
			delayValue : 0,
			cashField : '',
			cashCondition : '==',
			cashValue : 0,
		}
	};
	@Input() writePermission: boolean = false;

	@Output() innerEvents = new EventEmitter();

	constructor() {}

	ngOnInit() {}

	hide(){
		let event:any = {
			hide : true
		}
		this.innerEvents.emit(event);
	}

	discard() {
		this.hide();
	}

	save() {
		console.log('save');
		let event:any = {
			hide : true,
			flowEvent : true,
			data : {
				type : 'saveEditedState',
				content : this.selected
			}
		}
		this.innerEvents.emit(event);
	}

	checkSettings() {
		console.log('SETTINGS',this.selected.settings);
	}

}
